/**
 * PolicyAnalyticsPage - Policy execution analytics dashboard
 *
 * Surfaces the PolicyAnalyticsDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides analytics on policy execution, rule effectiveness, and compliance metrics.
 *
 * Route: /admin/policy-analytics
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconScale } from '@tabler/icons-react';

import { PolicyAnalyticsDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function PolicyAnalyticsPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="blue">
            <IconScale size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Policy Analytics</Title>
            <Text size="sm" c="dimmed">
              Policy execution metrics, rule effectiveness, and compliance analytics
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <PolicyAnalyticsDashboard />
    </Container>
  );
}

export default PolicyAnalyticsPage;
